import { orchestrator } from 'satcheljs';
import { contactSupport } from 'owa-premium-support-option/lib/actions/contactSupport';
import { toggleCharm, HeaderCharmType } from 'owa-header-store';
import { isFeatureEnabled } from 'owa-feature-flags';

export default orchestrator(contactSupport, () => {
    isFeatureEnabled('fwk-o365shellheader')
        ? (window as any).O365Shell.FlexPane.OpenFlexPaneForProvider('OwaHelp')
        : toggleCharm(HeaderCharmType.HelpCharm);
});
